import React from "react";

function QRcard(props){
    return(
        <div id={`${props.id}`} className="card border-secondary QR-box">
          <img className="card-img-top" src={`https://qrtag.net/api/qr_transparent_6.svg?url=${props.url}`} alt="qrtag"/>
          <div className="card-body">
            <h5 className="card-title text-center">{props.name}</h5>
            <a href={props.url} target="_blank" rel="noreferrer" className="btn btn-secondary btn-block">Open</a>
            <button className="btn btn-danger btn-block" onClick={() => props.delete(props.id)}>Delete</button>
          </div>
        </div>
    );
}

export default QRcard;